import React from 'react';
import { Line } from 'react-chartjs-2';
import { useLineChart } from '../../../helpers/use_line_chart';

interface ContactsWidgetChartProps {
  data: {
    active_members_graph_data?: Array<{ date: string; count: number }>;
  };
}

const ContactsWidgetChart: React.FC<ContactsWidgetChartProps> = ({ data }) => {
  const chartParams = {
    lineColor: '#dfebba',
    yFormat: '2d',
    xFormat: '%b',
    tooltipXFormat: '%d-%b',
    fillArea: true,
    lineType: 'monotone' as const,
    margin: { top: 5, left: 5, right: 5, bottom: 5 },
    maxTicksLimit: 6,
  };

  const transformedData = (data?.active_members_graph_data || []).map((item) => ({
    x: item.date,
    y: item.count,
  }));

  const { chartRef, chartData, chartOptions } = useLineChart(transformedData, chartParams);

  return <Line ref={chartRef} data={chartData} options={chartOptions} />;
};

export default ContactsWidgetChart;
